<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/basic/warehouse/location/page"
        getKey="rows" :columns="columns">
    </yi_curd_table>

  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_wms_purchase_receipt_check_warehouse_location_code',
  components: {
  },
  data() {
    return {
      columns: [ {
        label: 'kuweibianma',
        prop: 'code',
        width: 150,
      }, {
        label: 'kuweimingcheng',
        prop: 'name',
        // width: 130,
      },
        {
          label: 'chuangjianren',
          prop: 'createByObject.nickname',
          width: 130,
        },
        {
          label: 'chuangjianshijian',
          prop: 'createTime',
          type: 'time',
          width: 130,
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = {
        areaId: this.$attrs.areaId,
      }
      this.yt.SELECT_URL = "/web/basic/warehouse/location/listByIds"
      this.yt.SELECT_RESULT_KEY = "data"
      this.yt.SELECT_ID = "id"
      this.yt.SELECT_TITLE = "name"
      this.yt.get(1);
    }, 300)
  },

  methods: {

  }
};
</script>
